<style>
     /* -----------gaurav code start------------ */
     .project-card.style4 {
      background-color: #fff;
      background-color: #fff;
      border-radius: 5px;
      -webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.09);
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.09);
    }

    .project-card.style4 {
      -webkit-box-align: center;
      -ms-flex-align: center;
      -ms-grid-row-align: center;
      align-items: center;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
    }

    .project-card {
      margin-bottom: 25px;
    }

    .project-card.style4 .project-img {
      position: relative;
      width: 270px;
      border-radius: 5px 0 0 5px;
    }

    .project-card .project-img {
      overflow: hidden;
    }

    a {
      color: #000;
      text-transform: inherit;
      text-decoration: none;
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
    }

    .project-card.style4 .project-img img {
      border-radius: 5px 0 0 5px;
    }

    .project-card .project-img img {
      -webkit-transition: 0.7s;
      transition: 0.7s;
    }

    img {
      max-width: 100%;
      height: auto;
    }

    img,
    svg {
      vertical-align: middle;
    }

    .project-card.style4 .project-info {
      position: relative;
      z-index: 1;
      padding: 25px 25px 25px 5px;
      width: calc(100% - 290px);
      margin-left: 20px;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .project-card.style4 .project-info h3 {
      font-size: 22px;
      margin: 0 0 15px;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    h3 a {
      font-size: 17px;
    }

    .post-metainfo {
      margin-bottom: 13px;
    }

    .list-style {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .post-metainfo li:last-child {
      margin-right: 0;
    }

    .post-metainfo li {
      display: inline-block;
      position: relative;
      padding-left: 20px;
      margin-right: 20px;
      font-size: 15px;
      -webkit-transition: 0.3s;
      transition: 0.3s;
    }

    .list-style li {
      list-style: none;
    }

    .post-metainfo li i {
      position: absolute;
      top: 5px;
      left: 0;
      font-size: 16px;
      line-height: 0.8;
      color: #C92730;
      -webkit-transition: 0.3s;
      transition: 0.3s;
    }

    .fa fa-calendar:before {
      content: "\eb29";
    }

    .post-metainfo li i {
      position: absolute;
      top: 5px;
      left: 0;
      font-size: 16px;
      line-height: 0.8;
      color: #C92730;
      -webkit-transition: 0.3s;
      transition: 0.3s;
    }

    .project-card:hover .project-img img {
      -webkit-transform: scale(1.05);
      transform: scale(1.05);
    }

    .event_outreach a:hover,
    .event_outreach a :focus {
      text-decoration: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      color: #000;
    }

    .event_outreach .link.style1 {
      color: #C92730;
    }

    .event_outreach .link:hover {
      color: #000;
    }

    .event_outreach .link:after {
      position: absolute;
      bottom: 0;
      left: 0;
      content: "";
      width: 0;
      height: 1px;
      background: #C92730;
      visibility: hidden;
      opacity: 0;
      -webkit-transition: all 0.4s ease-in-out;
      transition: all 0.4s ease-in-out;
    }

    /* ------------------gaurav code end -------------- */
</style>
                  <div class="container event_outreach">
                    <div class="row">
                      <div class="content-header-left col-md-12 col-12 mb-2">
                        <div class="col-xl-12 text-center pb-2 pt-5">
                          <h1>Events & Outreach</h1>
                        </div>
                      </div>
                      <div class="row justify-content-center">

                        <div class="col-xl-6 col-lg-12 col-md-12">
                          <div class="project-card style4 blog">
                            <div class="project-img">
                              <a href="{{documentURL}}/events/Introductory_Meeting_between_MNRE_and_TCPs_Working_on.pdf"
                                target="_blank"> <img src="assets/images/events/iea_tcp_meeting.jpg" alt="Image"></a>
                            </div>
                            <div class="project-info">
                              <h3><a
                                  href="{{documentURL}}/events/Introductory_Meeting_between_MNRE_and_TCPs_Working_on.pdf"
                                  target="_blank">Introductory Meeting between MNRE and TCPs Working on Renewable Technologies, Fuels, and their System Integration
                                </a></h3>



                              <ul class="post-metainfo  list-style">
                                <li><i class="fa fa-calendar"></i>7th November 2023</li>
                              </ul>
                              <p>
                              </p>
                              <hr>
                              <p></p>

                              <ul class="fund-collection list-style">
                                <li class="fund-raised">

                                </li>

                              </ul>
                              <a href="{{documentURL}}/events/Introductory_Meeting_between_MNRE_and_TCPs_Working_on.pdf"
                                class="link style1">Read more<i class="flaticon-right-arrow"></i></a>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-6 col-lg-12 col-md-12">
                          <div class="project-card style4 blog">
                            <div class="project-img">
                              <a href="{{documentURL}}/events/INDIA_EU_Trade_and_Technology_Council_(TTC).pdf"
                               target="_blank"> <img src="assets/images/events/eu_ttc_workshop.jpg"
                                  alt="Image"></a>
                            </div>
                            <div class="project-info">
                              <h3><a
                                  href="{{documentURL}}/events/INDIA_EU_Trade_and_Technology_Council_(TTC).pdf"
                                  target="_blank">INDIA-EU Trade and Technology Council (TTC) Working Group 2 on Green and Clean Energy Technologies International Workshop Hybrid Format
                                </a></h3>



                              <ul class="post-metainfo  list-style">
                                <li><i class="fa fa-calendar"></i>22nd September 2023</li>
                              </ul>
                              <p>
                              </p>
                              <hr>
                              <p></p>

                              <ul class="fund-collection list-style">
                                <li class="fund-raised">

                                </li>

                              </ul>
                              <a href="{{documentURL}}/events/INDIA_EU_Trade_and_Technology_Council_(TTC).pdf"
                              target="_blank" class="link style1">Read more<i class="flaticon-right-arrow"></i></a>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-6 col-lg-12 col-md-12">
                          <div class="project-card style4 blog">
                            <div class="project-img">
                              <a
                                href="{{documentURL}}/events/Workshop_on_Solar_Thermal_Technologies.pdf" target="_blank">
                                <img src="assets/images/events/workshop_on_solar_thermal.jpg" alt="Image"></a>
                            </div>
                            <div class="project-info">
                              <h3><a href="{{documentURL}}/events/Workshop_on_Solar_Thermal_Technologies.pdf" target="_blank"> MNRE Workshop on Solar Thermal Technologies
                                </a></h3>



                              <ul class="post-metainfo  list-style">
                                <li><i class="fa fa-calendar"></i>13th September 2023</li>
                              </ul>
                              <p>
                              </p>
                              <hr>
                              <p></p>

                              <ul class="fund-collection list-style">
                                <li class="fund-raised">

                                </li>

                              </ul>
                              <a href="{{documentURL}}/events/Workshop_on_Solar_Thermal_Technologies.pdf"
                                class="link style1" target="_blank">Read more<i class="flaticon-right-arrow"></i></a>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-6 col-lg-12 col-md-12">
                          <div class="project-card style4 blog">
                            <div class="project-img">
                              <a href="{{documentURL}}/events/Workshop_on_AgriPV_in_India_Scope_and_Prospects.pdf"
                              target="_blank"> <img
                                  src="assets/images/events/mnre_workshop_on_agri_pv.png" alt="Image"></a>
                            </div>
                            <div class="project-info">
                              <h3><a
                                  href="{{documentURL}}/events/Workshop_on_AgriPV_in_India_Scope_and_Prospects.pdf"
                                  target="_blank" >MNRE Workshop on Agri PV
                                </a></h3>



                              <ul class="post-metainfo  list-style">
                                <li><i class="fa fa-calendar"></i>23rd June 2023</li>
                              </ul>
                              <p>
                              </p>
                              <hr>
                              <p></p>

                              <ul class="fund-collection list-style">
                                <li class="fund-raised">

                                </li>

                              </ul>
                              <a href="{{documentURL}}/events/Workshop_on_AgriPV_in_India_Scope_and_Prospects.pdf"
                                class="link style1" target="_blank">Read more<i class="flaticon-right-arrow"></i></a>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-6 col-lg-12 col-md-12">
                          <div class="project-card style4 blog">
                            <div class="project-img">
                              <a
                                href="{{documentURL}}/events/R&D _Conclave_on_Renewable_Energy.pdf" target="_blank">
                                <img
                                  src="assets/images/events/secretary-photo.png"
                                  alt="Image"></a>
                            </div>
                            <div class="project-info">
                              <h3><a
                                  href="{{documentURL}}/events/R&D _Conclave_on_Renewable_Energy.pdf" target="_blank">
                                  R&D Conclave on Renewable Energy 
                                </a></h3>



                              <ul class="post-metainfo  list-style">
                                <li><i class="fa fa-calendar"></i>11th April 2023</li>
                              </ul>
                              <p>
                              </p>
                              <hr>
                              <p></p>

                              <ul class="fund-collection list-style">
                                <li class="fund-raised">

                                </li>

                              </ul>
                              <a href="{{documentURL}}/events/R&D _Conclave_on_Renewable_Energy.pdf"
                                class="link style1" target="_blank">Read more<i class="flaticon-right-arrow"></i></a>
                            </div>
                          </div>
                        </div>

                        <div class="col-xl-6 col-lg-12 col-md-12"></div>
                        
                        
                       
                        
                        


                      </div>

                    </div>
           